exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapsed>.when-open[data-v-4750e5a4],.not-collapsed>.when-closed[data-v-4750e5a4]{display:none}", ""]);

// exports
